export const filterMonitorSearchResults = (monitors, query) => {
    const normalizedQuery = query.toLowerCase();
    return monitors.filter(monitor =>
        typeof monitor.name === 'string' &&
        monitor.name.toLowerCase().includes(normalizedQuery)
    );
};
